import easyPlugins from "../src/shared/store/easyPlugins";

window.EasyPlugins = easyPlugins;
